<template>
  <category-form />
</template>

<script>
import CategoryForm from '@/components/forms/CategoryForm'
export default {
  components: {
    CategoryForm
  }
}
</script>
